import React from 'react';
import { useParams, useNavigate } from "react-router-dom";
import { Container, Row, Col } from 'react-bootstrap';

import PDFViewer from '../elements_pdf/PDFViewer';
// import { Container, Row, Col, Form } from 'react-bootstrap';
// ? import { resolve } from 'path';
// ? import resolve from 'path-resolve';

const ViewPDF = () => {
  const { viewid } = useParams();
  const navigate = useNavigate();
  // const path = require('path');
  // const path = resolve(path);

  // console.log("Get into ViewPDF id: ", viewid);
  if (!viewid) return (null);
  const pathsplit = viewid.split(',');
  const PdfDir = pathsplit[0];
  const PartNo = pathsplit[1];
  const viewPath = "/PdfFile/" + PdfDir + '/' + PartNo + ".pdf";

  // file.mv(`${__dirname}/client/public/uploads/${file.name}`, err => {
  // app.use(express.static(path.join(__dirname, "../PdfFile")));
  // const viewPath = "/assets/"+ PdfDir + '/' + PartNo + ".pdf";
  // const storesFolderPath = path.join(__dirname, '..', 'stores');
  // console.log("Get into ViewPDF storesFolderPath : ", storesFolderPath);

  // const viewPath = __dirname + "..\\..\\PdfFile\\" + PdfDir + '\\' + PartNo + ".pdf";
  // const viewPath = "\\..\\..\\PdfFile\\" + PdfDir + '\\' + PartNo + ".pdf";

  // console.log("Get into ViewPDF viewPath: ", viewPath);
  // const process = require('process');
  // console.log("Get into ViewPDF viewPath/Current working directory : ", process.cwd());

  // console.log("Get into ViewPDF __dirname: ", __dirname);
  // console.log("Get into ViewPDF __filename: ", __filename);
  // console.log('../../xxx : ', path.resolve('../../server'));

  // x console.log("Get into ViewPDF process.cwd() : ", process.cwd());
  // const SensorDrawingPath = "/assets/SensorDrawing/" + PartNo + ".pdf";
  // const SensorSpecPath = "/assets/SensorSpec/" + PartNo + ".pdf";
  // var filepath;

  // if (pdfType === 'Drawing') { filepath = SensorDrawingPath }
  // if (pdfType === 'Spec') { filepath = SensorSpecPath }

  return (
    <div className='container-fluid bg-primary-subtle'>
      <br /> <br /> <br /> <br /> <br /> 
      {/* <div className='d-flex justify-content-center align-items-center flex-column'> */}
      <Container className='container-fluid'>
        <Row>
          <Col className='col-md-6'> </Col>
          <Col className='col-md-6 justify-content-start'>
            <button className='btn btn-success' onClick={() => navigate(-1)}>Back</button>
          </Col>
        </Row>
        <Row>
          <PDFViewer filepath={viewPath} />
        </Row>
      </Container>
    </div>
  )
}

export default ViewPDF